import React, { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";

import styled from "styled-components";

import useToast from "components/atoms/toast/useToast";

import ReferenceBibInfoForm from "components/organisms/reference/ReferenceBibInfoForm";
import AbstractModalFooter from "components/page/modal/AbstractModalFooter";

import { getDefaultBibtex } from "utils/bibtex";

const Container = styled.div`
    width: 100%;
`;

function ReferenceAddFormModal(props) {
    const { setToast } = useToast();

    const formRef = useRef();
    const nav = useNavigate();
    const { space_uuid } = useParams();
    const handleAddButton = () => {
        formRef.current.bibJsonMutate(formRef.current.getCurrentBibJson(), {
            onSuccess: (data) => {
                setToast("저장되었습니다.", "info");
                nav(`/${space_uuid}/reference/${data.reference_no}`);
            },
        });
    };

    return (
        <Container>
            <ReferenceBibInfoForm
                ref={formRef}
                bibliography={{
                    id: undefined,
                    bib_json: getDefaultBibtex().bib_json,
                }}
            />
            <AbstractModalFooter
                leftBtnText={"취소"}
                rightBtnText={"추가"}
                leftOnClick={props.exitModal}
                rightOnClick={handleAddButton}
            />
        </Container>
    );
}

export default ReferenceAddFormModal;
